import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "./faq.css";

function FAQ() {
  return (
    <div>
      <Header />
      <div className="faq-container">
        <h1>Foire Aux Questions</h1>

        <div className="faq-section">
          <h3>Qu&apos;est-ce que votre entreprise fait exactement ?</h3>
          <p>
            Notre entreprise est sp&eacute;cialis&eacute;e dans le
            d&eacute;veloppement de logiciels, la cr&eacute;ation de sites
            internet et d&apos;applications mobiles, ainsi que la mise en place
            de r&eacute;seaux d&apos;entreprise.
          </p>
        </div>

        <div className="faq-section">
          <h3>Quelles sont vos r&eacute;f&eacute;rences et exp&eacute;riences ?</h3>
          <p>
            Nous avons travaill&eacute; avec de nombreuses entreprises de
            diff&eacute;rents secteurs d&apos;activit&eacute;, de la PME aux
            grands groupes. Vous pouvez consulter notre portefeuille pour en
            savoir plus sur nos r&eacute;alisations.
          </p>
        </div>

        <div className="faq-section">
          <h3>Quel est votre processus de travail ?</h3>
          <p>
            Nous suivons une m&eacute;thode agile de d&eacute;veloppement, qui
            nous permet d&apos;adapter notre travail aux besoins et aux
            &eacute;volutions du projet. Nous travaillons en &eacute;troite
            collaboration avec nos clients et assurons une communication
            r&eacute;guli&egrave;re tout au long du projet.
          </p>
        </div>

        <div className="faq-section">
          <h3>Quels sont vos tarifs ?</h3>
          <p>
            Nos tarifs varient en fonction de la complexit&eacute; du projet et
            des services demand&eacute;s. Nous proposons des devis sur mesure en
            fonction des besoins de chaque client.
          </p>
        </div>

        <div className="faq-section">
          <h3>Comment se d&eacute;roule le suivi apr&egrave;s livraison ?</h3>
          <p>
            Nous assurons un suivi apr&egrave;s livraison pour garantir la
            satisfaction de nos clients et la maintenance du produit. Nous
            proposons des contrats de support et des formations pour faciliter
            la prise en main.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default FAQ;
